import { useField } from '@common/hooks/use-field.hook';
import React, { useCallback } from 'react';
import { ITimePickerChangeHandler, ITimePickerProps, TimePicker } from './time-picker.component';

export function FormTimePicker<TFormValues>(
    props: Omit<ITimePickerProps<keyof TFormValues>, 'value' | 'defaultValue'>,
): JSX.Element {
    const { onChange, onBlur, getCustomErrorMessage } = props;
    const { setFieldValue, setFieldTouched, value, errorMessage, triggerValidate } = useField<Date | undefined>({
        ...props,
        getCustomErrorMessage,
    });

    const handleChange = useCallback<ITimePickerChangeHandler>(
        (e) => {
            onChange && onChange(e);
            setFieldValue(e.value);

            triggerValidate();
        },
        [setFieldValue, onChange, triggerValidate],
    );

    const handleBlur = useCallback(
        (e: React.FocusEvent<HTMLInputElement>) => {
            onBlur && onBlur(e);
            setFieldTouched();
        },
        [onBlur, setFieldTouched],
    );

    return (
        <TimePicker
            errorMessage={errorMessage}
            {...props}
            onChange={handleChange}
            onBlur={handleBlur}
            name={props.name as string}
            value={value}
        />
    );
}
